/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import apiClient from "../../lib/common/apiClient";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";

function UserCreateButton ( props ) {
    const {t} = useTranslation();
    const {id, schema, refresh, onSuccess, ...others} = props;
    const [open, setOpen] = useState(false);
    const [modifiedSchema, setModifiedSchema] = useState();

    useEffect (() => {
        let mounted = true;
        async function schemaSetting() {
            let modifiedSchema = cloneDeep(schema);
            if(mounted) {
                let result = await apiClient.get("/api/User/userCompanyCode/pri");
                let defaultCompany = "";
                if(result.data[0]) {
                    defaultCompany = result.data[0].userCompanyCode;
                }

                modifiedSchema.columns.forEach((column) => columnSetting(column, defaultCompany));
            }
            setModifiedSchema(modifiedSchema);
        }

        function columnSetting(column, defaultCompany) {
            switch(column.name) {
                case "userCompanyCode" :
                    column.defaultValue = defaultCompany;
                    break;

                default :
            }
        }

        schemaSetting();
        
        return (() => {
            mounted = false;
        });
    }, []);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess (msg);
        }
        refresh.refresh();
    };

    return (
        <>
            <CreateRecordButtonLayout id={id+"append-button"} onClick={onOpen} {...others} />
            <AutoFormDialog
                id={id+"append-dialog"}
                formId={id+"append-form"}
                title={t(`dialog.title.${schema.name}.create`)}
                schema={modifiedSchema}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
            />
        </>
    );
}

export default UserCreateButton;

